import React from "react";

const AssignedIcon = ({ color = "#6D7885", ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...rest}
    fill="none"
    stroke={color}
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="9.85" cy="5.95" r="3.55" />
    <path d="M12.9 18.1H2.2a.45.45 0 0 1-.45-.45v-.55a5.4 5.4 0 0 1 5.4-5.4h3.4a6.1 6.1 0 0 1 3.8 1.37" />
    <circle cx="17.55" cy="17" r="4.7" />
    <path d="m15.45 17.25 1.25 1.25 2.85-2.95" />
  </svg>
);

export default AssignedIcon;
